export const LIST_PATH = '/app/summary-feedback'

/** Cursors of the pages before the current one, oldest first; `''` is the first page. */
export type ListPageState = { cursors: string[] }

/** What a list row hands the detail page so Back lands on the same page of results. */
export type ListReturn = { search: string; listState: ListPageState | null }

const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === 'object' && value !== null

export const readListPageState = (state: unknown): ListPageState | null =>
  isRecord(state) && Array.isArray(state.cursors) && state.cursors.every((c) => typeof c === 'string')
    ? { cursors: state.cursors as string[] }
    : null

// Only a query string is accepted, so router state can never send Back somewhere other than the list.
export const readListReturn = (state: unknown): ListReturn | null => {
  if (!isRecord(state) || typeof state.search !== 'string') return null
  if (state.search !== '' && !state.search.startsWith('?')) return null
  return { search: state.search, listState: readListPageState(state.listState) }
}
